<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Gestion des statuts et leurs catégories</strong>
          </div>
            <b-tabs>
              <b-tab active>
                <template slot="title">
                  <i class="cui-task"></i>
                  {{ tabs[0] }}
                </template>
                <status-component>
                  <edit-status></edit-status>
                </status-component>
              </b-tab>
              <b-tab>
                <template slot="title">
                  <i class="cui-note"></i>
                  {{ tabs[1] }}
                </template>
                <category-component></category-component>
              </b-tab>
            </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import StatusComponent from './GestionStatus'
import CategoryComponent from './GestionCategorie'
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
  components: { StatusComponent, CategoryComponent },
  data() {
    return {
      tabs: ["Statuts", "Catégories"]
    }
  },
  mounted() {

  },
  created() {

  },
  methods: {

  }
}
</script>

<style>

</style>
